<div #controlContainer class="container">
  <label [for]="this.config().placeholder" class="input-label">{{
    config().placeholder
  }}</label>
  <input
    class="input"
    type="text"
    [id]="this.config().placeholder"
    [formControl]="this.textControl"
    [value]="this.textControl.value"
  />
</div>
@if (this.textControl.invalid && (this.textControl.dirty ||
this.textControl.touched)) {
<br />
<app-validation-hint
  [controlContainer]="controlContainer"
  [textControl]="this.textControl"
  [translationName]="this.config().placeholder"
></app-validation-hint>

}
